<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Absensi Karyawan 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
            <b-input-group >
              <b-input-group-prepend><label style="width:90px !important;">Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label style="width:90px !important;">NIK</label></b-input-group-prepend>
              <b-form-input v-model="tblData.employee_nik" ></b-form-input>
              <!-- <b-input-group-prepend><span class="input-group-text">Type</span></b-input-group-prepend>
              <b-form-select v-model="tblData.type" :plain="true" :options="optType"></b-form-select> -->
            </b-input-group>
        </b-col>
        <b-col  lg="5">
            <b-input-group >
              <b-input-group-prepend><label style="width:90px !important;">Name</label></b-input-group-prepend>
              <b-form-input v-model="tblData.employee_name" placeholder="Employee Name" ></b-form-input>
                <b-input-group-append><b-button class="btn btn-success ml-1" style="width:110px !important;" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
            </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label style="width:90px !important;">Position</label></b-input-group-prepend>
            <b-form-input v-model="tblData.job_position" placeholder="Job Position"></b-form-input>
            <b-input-group-append><b-button class="btn btn-secondary ml-1" style="width:110px !important;" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
        <b-table
        class="mb-0"
            ref="tblPhoto"
            responsive
            striped hover 
            style="font-size:smaller;"
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
        <template v-slot:cell(date)="data">
          <span v-if="(data.item.date)">
          {{ data.item.date | moment("DD MMM YYYY") }}
          </span>
        </template>

        <template v-slot:cell(day)="data">
          <span v-if="(data.item.date)">
          {{ data.item.date | moment("dddd") }}
          </span>
        </template>

        <template v-slot:cell(time_in)="data">
            <span>
              <span style="width: 100%;" v-if="(data.item.time_in)">
                {{ data.item.time_in | moment("HH:mm") }}
              </span>
            </span>
        </template>

        <template v-slot:cell(gps_coordinate_in)="data">
          <span>
            <span style="width: 100%;" v-if="(data.item.addressLine_in)">
              {{ data.item.addressLine_in }}
              <hr>
            </span>
            <span style="width: 100%;" v-if="(data.item.gps_coordinate_in)">
              Lat, Long: {{ data.item.gps_coordinate_in }}
            </span>
          </span>
        </template>

        <template v-slot:cell(time_out)="data">
            <span>
              <span style="width: 100%;" v-if="(data.item.time_out)">
                {{ data.item.time_out | moment("HH:mm") }}
              </span>
            </span>
        </template>

        <template v-slot:cell(gps_coordinate_out)="data">
          <span>
            <span style="width: 100%;" v-if="(data.item.addressLine_out)">
              {{ data.item.addressLine_out }}
              <hr>
            </span>
            <span style="width: 100%;" v-if="(data.item.gps_coordinate_out)">
              Lat, Long: {{ data.item.gps_coordinate_out }}
            </span>
          </span>
        </template>

          <template v-slot:cell(thumbnail_in)="data">
              <div>
                  <img :src="data.item.thumbnail_in" class="img-fluid" alt />
              </div>
          </template>
          <template v-slot:cell(thumbnail_out)="data">
              <div>
                  <img :src="data.item.thumbnail_out" class="img-fluid" alt />
              </div>
          </template>
        <template v-slot:cell(photoexif_in)="data">
          {{ getDeviceModel(data.item.photoexif_in) }}
        </template>
        <template v-slot:cell(photoexif_out)="data">
          {{ getDeviceModel(data.item.photoexif_out) }}
        </template>
        <template v-slot:cell(gps_enabled)="data">
          <p v-if="(data.item.gps_enabled)">
           Enabled : {{ data.item.gps_enabled }}
          </p>
          {{ data.item.gps_permission }}
        </template>
          </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <!-- <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>         -->

  </div>
</template>

<script>
// import moment from "moment";
import absen from "../../apis/bakeryabsen";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuCustomer from "../lookup/lkuCustomer";
import toastr from "mini-toastr";
toastr.init();

export default {
  components :{Loading,lkuCustomer},
  data() {
    return {
      fields: [
        {
          key: "action",
          label: "",
          thStyle: "width:30px",
          thClass: "text-center",
        },
          {
            key: "date",
            label: "Date",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "day",
            label: "Day",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "employee_nik",
            label: "NIK",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "employee_name",
            label: "Employee Name",
            sortable: true
          },
          {
            key: "job_position",
            label: "Job Position",
            sortable: true
          },
          {
            key: "date_in",
            label: "Date IN",
            variant: "success",
            thStyle: "width:100px;",
            sortable: true
          },
          {
            key: "time_in",
            label: "Time IN",
            variant: "success",
            thStyle: "width:100px;",
            sortable: true
          },
          {
            key: "gps_coordinate_in",
            label: "Location IN",
            variant: "success",
            thStyle: "width:300px;",
            sortable: true
          },
          {
            key: "photoexif_in",
            label: "Device IN",
            variant: "success",
            thStyle: "width:100px;",
            sortable: true
          },
          {
            key: "thumbnail_in",
            label: "Photo IN",
            variant: "success",
            sortable: true
          },
          {
            key: "date_out",
            label: "Date OUT",
            variant: "danger",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "time_out",
            label: "Time OUT",
            variant: "danger",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "gps_coordinate_out",
            label: "Location OUT",
            variant: "danger",
            thStyle: "width:300px;",
            sortable: true
          },
          {
            key: "photoexif_out",
            label: "Device OUT",
            variant: "danger",
            thStyle: "width:100px;",
            sortable: true
          },
          {
            key: "thumbnail_out",
            label: "Photo OUT",
            variant: "danger",
            sortable: true
          },
          // {
          //   key: "type_in",
          //   label: "Type IN",
          //   thStyle: "width:100px",
          //   sortable: true
          // },
          // {
          //   key: "type_out",
          //   label: "Type OUT",
          //   thStyle: "width:100px",
          //   sortable: true
          // },
          // {
          //   key: "remark",
          //   label: "Remark",
          //   thStyle: "width:100px",
          //   sortable: true
          // },
          // {
          //   key: "createby",
          //   label: "Diposting oleh",
          //   sortable: true
          // },
          // {
          //   key: "photothumbnail",
          //   label: "Photo",
          // },
          // {
          //   key: "photoexif",
          //   label: "Meta data",
          //   thStyle: "width:220px",
          // },
          // {
          //   key: "gps_coordinate",
          //   thClass: "text-center",
          //   tdClass: "text-center",
          //   label: "GPS Coordinate",
          //   sortable: true
          // },
          // {
          //   key: "gps_enabled",
          //   thClass: "text-center",
          //   tdClass: "text-center",
          //   label: "HP Location Service",
          //   sortable: true
          // },
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'date',
        sortDesc: true,
        headcategory:null,
        type:""
      },
      limit:10,
      pagination: false,
      items:[],
      model:{},showFrm:false,
      lkuItemShow:false,
      itemList:{},
      lkuCustomerShow:false,
        uanguser: this.$store.state.user.matauang,
      isLoading:false,
      showDelConfirm: false,
      showFilter:false,
      showList:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
        activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Discontinued' },{ value: '1', text: 'Active/In Use' }],
        jasaMaterial : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Material ' },{ value: '1', text: 'Service' }],
      headCategories:[], itemCategories:[],
      optType: [
        { value: "", text: "--- ALL ---" },
        { value: "type_in", text: "Clock IN" },
        { value: "type_out", text: "Clock OUT" },
      ],
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },  
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },      
  },   
  methods: {

    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.photolist) {
            this.tblData[key] = filter.photolist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.photolist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.photolist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await absen.list(this.tblData);
                  list.map(data=>{
                      if(data.time_in && data.time_out && (data.modified_out < data.modified_in)){
                        data.date_in = "";
                        data.time_in = "";
                        data.gps_coordinate_in = "";
                        data.addressLine_in = "";
                        data.photoexif_in = "";
                        data.thumbnail_in = "";
                      }
                  });
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await absen.list(this.tblData);
              list.map(data=>{
                  if(data.time_in && data.time_out && (data.modified_out < data.modified_in)){
                    data.date_in = "";
                    data.time_in = "";
                    data.gps_coordinate_in = "";
                    data.addressLine_in = "";
                    data.photoexif_in = "";
                    data.thumbnail_in = "";
                  }
              });
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },    
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblPhoto.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.job_position =  '';
        this.tblData.employee_nik = '';
        this.tblData.employee_name =  '';
        this.tblData.type =  '';
        this.tblData.tgl1 =  '';
        this.tblData.tgl2 =  '';
        this.refresh();
    },    
    // customerChange: function () {
    //     this.tblData.customer_id = '';
    // },        
    saveFilter() {
      const keys = ['tgl1', 'tgl2', 'type', 'job_position', 'employee_nik', 'employee_name'];
      let filtered = false;
      const photolist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              photolist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          photolist.page=this.tblData.page;
          photolist.limit=this.tblData.limit;
          photolist.sortBy=this.tblData.sortBy;
          photolist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.photolist=photolist;
          this.$store.commit("filter", filter);
      }
    },    
    // onSelectLkuCustomer: async function (_selected) {
    //     this.tblData.customer = _selected.CustName.trim();
    //     this.tblData.custcode = _selected.CustCode;
    //     this.tblData.customer_id = _selected.customer_id;
    //     this.lkuCustomerShow=false;
    // },    
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },    
    rowDownload(record) {
      this.rowClicked(record);
      this.download();
    },    
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await absen.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.itemno==this.model.itemno));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    download : async function(fl) {
        if (this.model) {
            try {
                this.isLoading=true;
                const response = await absen.download(this.model);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.model.remark}_${this.model.orderno}_${this.model.CustCode}.jpg`);
                document.body.appendChild(link);
                link.click();
                this.isLoading=false;    
            } catch (error) {
                    this.isLoading=false;            
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        } else {
            toastr.warn('Please select a row that want to be Download!');
        }

    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await absen.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    }, 
    getDeviceModel(data){
      if(data){
        let dataExif = JSON.parse(data);
      let deviceMake = "";
      let deviceModel = "";
      for(let key in dataExif) {
        if(dataExif.hasOwnProperty(key)) {
          if (key == "Model") {
            var value = dataExif[key];
            deviceModel = value;
          }
          if (key == "Make") {
            var value = dataExif[key];
            deviceMake = value;
          }
        }
      }
      return `${deviceMake} - ${deviceModel}`;
      }else{
        return "";
      }
    },
    close(){
      router.push("home");
    },    
  }
};
</script>
